// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"ScheduledAppointment_Tooltip__2qgE5"};